import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager , JhiLanguageService  } from 'ng-jhipster';

import { Boothfee } from './boothfee.model';
import { BoothfeeService } from './boothfee.service';

@Component({
    selector: 'jhi-boothfee-detail',
    templateUrl: './boothfee-detail.component.html'
})
export class BoothfeeDetailComponent implements OnInit, OnDestroy {

    boothfee: Boothfee;
    private subscription: any;
    private eventSubscriber: Subscription;

    constructor(
        private eventManager: EventManager,
        private jhiLanguageService: JhiLanguageService,
        private boothfeeService: BoothfeeService,
        private route: ActivatedRoute
    ) {
        this.jhiLanguageService.setLocations(['boothfee']);
    }

    ngOnInit() {
        this.subscription = this.route.params.subscribe((params) => {
            this.load(params['id']);
        });
        this.registerChangeInBoothfees();
    }

    load(id) {
        this.boothfeeService.find(id).subscribe((boothfee) => {
            this.boothfee = boothfee;
        });
    }
    previousState() {
        window.history.back();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        this.eventManager.destroy(this.eventSubscriber);
    }

    registerChangeInBoothfees() {
        this.eventSubscriber = this.eventManager.subscribe('boothfeeListModification', (response) => this.load(this.boothfee.id));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/boothfee/boothfee-detail.component.ts